<template>
  <PageLayout
    :page-title="pageTitle"
    :show-breadcrumbs="false"
    :show-page-header="false"
    :breadcrumb-items="breadcrumbItems"
    :locale="locale"
  >
    <div>
      <!-- Page Header -->
      <div class="page-header">
        <div class="row">
          <div class="col">
            <h3 class="page-title">{{ $t("sales.payments") }} </h3>
          </div>
          <div class="col-auto text-right">
            <!-- Remove these two buttons -->
            <!-- <a class="btn btn-white filter-btn mr-2" href="javascript:void(0);" id="filter_search"
               @click="toggleFilterDrawer">
              <i class="fas fa-filter"></i>
            </a>
            <button class="ml-2 btn btn-outline-info" @click="downloadReceiptsPdf">
              <i class="fas fa-file-pdf"></i> Export To Pdf
            </button> -->

            <!-- Keep just the Create button -->
            <button v-if="showButton" @click="navigateToCreateReceipt" :disabled="isLoading"
                    :title="buttonTooltip" class="btn btn-primary ml-2 first-button">
              <i class="fas fa-plus"></i> New {{ $t('sales.payment') || 'Payment' }}
            </button>
            <button v-if="showButton" @click="navigateToCreateReceipt" :disabled="isLoading" :title="buttonTooltip"
                    class="btn btn-primary ml-3 second-button">
              <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- /Page Header -->

      <div ref="receiptsContainer" class="row vld-parent">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="search-container">
                    <div class="input-group">
                      <div class="input-group-prepend" hidden>
                        <select
                          class="input-group-text form-control bg-primary"
                          v-model="selectedSearchFilterId"
                          @change="changeSearchFilter"
                          :disabled="isLoading"
                          :required="true">
                          <option
                            v-for="searchFilter in searchFilters"
                            :key="searchFilter"
                            :value="searchFilter"
                            :name="searchFilter"
                            :selected="searchFilter">
                            {{ searchFilter }}
                          </option>
                        </select>
                      </div>
                      <input class="form-control" type="text"
                             v-model="searchValue"
                             @keyup.enter="searchReceipts($event)"
                             placeholder="Search by number..."
                      >
                      <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="searchReceipts(null)"
                                :disabled="isLoading">
                          <i class="fas fa-search"></i>
                        </button>
                        <button v-if="!isCustomerContact" class="btn btn-outline-default d-none d-md-inline-block ml-2" type="button"
                                @click="toggleFilterDrawer" :disabled="isLoading">
                          <i class="fas fa-filter"></i> <span class="filter-text">Filters</span>
                        </button>
                        <button v-if="!isCustomerContact" class="btn btn-outline-default d-inline-block d-md-none ml-2" type="button"
                                @click="toggleFilterDrawer" :disabled="isLoading">
                          <i class="fas fa-filter"></i>
                        </button>
                        <div v-if="!isCustomerContact" class="btn-group ml-2 d-none d-md-inline-flex">
                          <button class="btn btn-outline-default dropdown-toggle" type="button" id="exportDropdown"
                                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                  :disabled="isLoading">
                            <i class="fas fa-download"></i> <span class="export-text">Export</span>
                          </button>
                          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="exportDropdown">
                            <a class="dropdown-item" href="#" @click.prevent="downloadReceiptsPdf">
                              <i class="fas fa-file-pdf"></i> Export to PDF
                            </a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="#" @click.prevent="downloadReceiptsExcel">
                              <i class="fas fa-file-excel"></i> Export to Excel
                            </a>
                          </div>
                        </div>
                        <!-- Mobile export button -->
                        <div v-if="!isCustomerContact" class="btn-group ml-2 d-inline-flex d-md-none">
                          <button class="btn btn-outline-default dropdown-toggle" type="button"
                                  id="exportDropdownMobile" data-toggle="dropdown" aria-haspopup="true"
                                  aria-expanded="false" :disabled="isLoading">
                            <i class="fas fa-download"></i>
                          </button>
                          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="exportDropdownMobile">
                            <a class="dropdown-item" href="#" @click.prevent="downloadReceiptsPdf">
                              <i class="fas fa-file-pdf"></i> PDF
                            </a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="#" @click.prevent="downloadReceiptsExcel">
                              <i class="fas fa-file-excel"></i> Excel
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr/>
              <div class="table table-responsive">
                <div>
                  <receipt-list-table :permissions="permissions"
                                      :receipts="receipts"
                                      :is-loading="isLoading"
                  ></receipt-list-table>

                  <div v-if="!receipts.length" class="text-center mt-5 mb-5">
                    <div v-if="!isLoading">No records found!</div>
                  </div>
                </div>
              </div>

              <div v-if="receipts.length" class="row">
                <div class="col-sm-12 col-md-5">
                  <div class="" id="tblProducts_info" receipt="status" aria-live="polite"
                       style="padding-top: 1.25em">
                    Show
                    <select disabled @change="onChangeRecordsPerPage" v-model="recordsPerPage">
                      <option :value="12">10</option>
                      <option :value="25">25</option>
                      <option :value="50">50</option>
                      <option :value="100">100</option>
                    </select>
                    of {{ totalRecords }} entries
                  </div>
                </div>
                <div class="col-sm-12 col-md-7">
                  <div class="dataTables_paginate paging_simple_numbers" id="tblProducts_paginate"
                       style="padding-top: 0.55em">
                    <pagination
                      :totalPages="totalPages"
                      :perPage="recordsPerPage"
                      :currentPage="currentPage"
                      @pagechanged="onPageChange"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Create Receipt Modal -->
      <div class="modal fade" id="create_receipt_modal" aria-hidden="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header bg-info-light">
              <h5 class="modal-title">Create {{ $t('sales.payment') || 'Payment' }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!--                <CreateMedicalReceiptForm :caseId="caseId" :customerId="customerId" ref="createMedicalReceiptForm"/>-->
            </div>
          </div>
        </div>
      </div>
      <!-- Create Receipt Modal -->

      <!-- Edit Receipt Modal -->
      <div class="modal fade" id="edit_receipt_modal" aria-hidden="true" role="dialog" ref="modal">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header bg-info-light">
              <h5 class="modal-title">Create {{ $t('sales.payment') || 'Payment' }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form action="">
                <div>
                  <div class="form-group">
                    <label>{{ $t('sales.payment') || 'Payment' }} Number</label>
                    <input readonly type="text" class="form-control" v-model="receipt.number" ref="receiptNumber"
                           placeholder="">
                  </div>
                  <div class="form-group">
                    <label class="required">Name</label>
                    <input type="text" class="form-control" v-model="receipt.name">
                  </div>
                  <div class="form-group">
                    <label>Email</label>
                    <input type="text" class="form-control" v-model="receipt.email">
                  </div>
                  <div class="form-group">
                    <label>Phone</label>
                    <input type="text" class="form-control" v-model="receipt.phone">
                  </div>
                  <div class="form-group">
                    <label>Address</label>
                    <input type="text" class="form-control" v-model="receipt.address">
                  </div>
                  <div class="mt-4">
                    <button class="btn btn-primary btn-block" @click="updateReceipt($event)">Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- Edit Receipt Modal -->
    </div>

    <!-- Filter Drawer -->
    <ReceiptFilterDrawer
      :is-open="isFilterDrawerOpen"
      :initial-filters="advancedFilters"
      @close="closeFilterDrawer"
      @filters-updated="handleFilterUpdate"
    />
    <div class="filter-overlay" :class="{ 'show': isFilterDrawerOpen }" @click="closeFilterDrawer"></div>
  </PageLayout>
</template>

<script>
import receiptService from "../../service/receipt.service";
import Pagination from "../Pagination";
import ReceiptListTable from "../receipts/ReceiptListTable";
import ReceiptFilterDrawer from "./ReceiptFilterDrawer";

import moment from "moment";
import {convertToLocalDate, convertToLocalTime} from "../../utils/utils";
import permissionService from "../../service/permission.service";
import {getConfig} from "../../utils/config"
import axios from "axios";
import {API_URL} from "../../utils/config.util";
import authHeader from "../../service/auth-header";
import DatePicker from "vue2-datepicker";
import {allowedModules} from "../../utils/modules";
import PageLayout from "../layouts/PageLayout.vue";
import {isCustomerContact as selectedContextIsCustomerContact} from "../../utils/customer.context";

export default {
  name: "receipts-list",
  components: {
    PageLayout,
    Pagination,
    ReceiptListTable,
    DatePicker,
    ReceiptFilterDrawer
  },
  data() {
    return {
      receiptId: null,
      receipt: {},
      receipts: [],
      showFilters: false,
      currentIndex: -1,
      searchValue: undefined,
      title: undefined,
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 25,
      filters: {
        name: null,
        email: null,
        phone: null
      },
      pageTitle: "",
      locale: this.$i18n.locale,
      breadcrumbItems: [
        {label: 'Home', to: '/dashboard'},
        {label: 'Payments', to: '/receipts'}
      ],
      selectedTime: null,
      selectedTemplateId: null,
      searchFilters: ["Number", "Currency"],
      selectedSearchFilterId: "Number",
      fullPage: false,
      showAddReceiptButton: false,
      caseId: undefined,
      isLoading: true,
      isFilterDrawerOpen: false,
      advancedFilters: null,
      permissions: {},
      pagePermissions: ['RECEIPTS_READ', 'RECEIPTS_SEARCH', 'RECEIPTS_CREATE', 'RECEIPTS_UPDATE', 'RECEIPTS_DELETE'],
      displayDisabledButtons: !getConfig().hideIfNoPermission,
      modules: [],
    };
  },
  methods: {
    disabledDates(date) {
      const today = new Date();
      return date > today;
    },
    navigateToCreateReceipt() {
      this.$router.push('/receipts/create')
    },
    generateName(firstName, lastName) {
      let name = null
      if (firstName && lastName) {
        name = firstName + ' ' + lastName;
      }
      if (firstName && !lastName) {
        name = firstName;
      }
      if (!firstName && lastName) {
        name = lastName;
      }
      return name;
    },
    formatToDate(date) {
      return moment(date).format("YYYY-MM-DD")
    },
    formatDateTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm")
    },
    formatTime(time) {
      return moment(time).format("HH:mm")
    },
    editReceipt(id) {
      this.receiptId = id
      this.retrieveReceipt(id)
      document.getElementById('showEditReceiptModal').click()
    },
    retrieveReceipt(id) {
      receiptService.findById(localStorage.getItem('mid'), id)
        .then(response => {
          this.receipt = response.data.data;
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', 'Oops', "Error occurred")
        });
    },
    toggleFilterDrawer() {
      this.isFilterDrawerOpen = !this.isFilterDrawerOpen;
      if (this.isFilterDrawerOpen) {
        document.body.classList.add('drawer-open');
      } else {
        document.body.classList.remove('drawer-open');
      }
    },
    closeFilterDrawer() {
      this.isFilterDrawerOpen = false;
      document.body.classList.remove('drawer-open');
    },
    handleFilterUpdate(filters) {
      // Store all filters for use in retrieveReceipts
      this.advancedFilters = filters;
      this.retrieveReceipts();

      // Always close the drawer after applying filters
      this.closeFilterDrawer();
    },
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
    },
    changeSearchFilter() {
      this.searchReceipts(null)
    },
    searchReceipts(e) {
      e ? e.preventDefault() : null
      this.isLoading = true;
      let params = {
        page: this.currentPage,
        size: this.recordsPerPage,
        op: 'like'
      }
      if (this.searchValue) {
        params[this.selectedSearchFilterId.toLowerCase()] = this.searchValue;
      }
      receiptService.find(localStorage.getItem("mid"), params)
        .then(response => {
          this.receipts = response.data.data;
          this.totalPages = response.data.pagination ? response.data.pagination.totalPages : 0
          this.totalRecords = response.data.pagination ? response.data.pagination.totalRecords : 0
        })
        .catch(e => {
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', "Error occurred", 5000)
        })
        .finally(() => {
          this.isLoading = false;
        })
    },
    retrieveReceipts() {
      this.isLoading = true;

      let params = {
        sortBy: 'date',
        sortOrder: 'DESC',
        page: this.currentPage,
        size: this.recordsPerPage
      };

      // Apply advanced filters if they exist
      if (this.advancedFilters) {
        // Add date range filters
        if (this.advancedFilters.number) {
          params.number = this.advancedFilters.number;
        }

        if (this.advancedFilters.startDate) {
          params.fromDate = moment(this.advancedFilters.startDate).startOf('day').toISOString();
        }

        if (this.advancedFilters.endDate) {
          params.toDate = moment(this.advancedFilters.endDate).endOf('day').toISOString();
        }

        // Add payment method filter
        if (this.advancedFilters.paymentMethodId) {
          params.paymentMethodId = this.advancedFilters.paymentMethodId;
        }

        // Add project filter
        if (this.advancedFilters.projectId) {
          params.projectId = this.advancedFilters.projectId;
        }

        // Add projectIdIsNull filter
        if (this.advancedFilters.projectIdIsNull) {
          params.projectIdIsNull = this.advancedFilters.projectIdIsNull;
        }

        // Add currency filter
        if (this.advancedFilters.currency) {
          params.currency = this.advancedFilters.currency;
        }

        // Add amount range filters
        if (this.advancedFilters.minAmount) {
          params.minAmount = parseFloat(this.advancedFilters.minAmount) * 100; // Convert to cents
        }

        if (this.advancedFilters.maxAmount) {
          params.maxAmount = parseFloat(this.advancedFilters.maxAmount) * 100; // Convert to cents
        }
      }

      receiptService.find(localStorage.getItem("mid"), params)
        .then(response => {
          this.receipts = response.data.data;
          this.totalPages = response.data.pagination ? response.data.pagination.totalPages : 0
          this.totalRecords = response.data.pagination ? response.data.pagination.totalRecords : 0
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('warning', "Oops", "Error occurred")
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    convertToLocalDate(utcDate, utcTime) {
      return convertToLocalDate(utcDate, utcTime)
    },
    convertToLocalTime(utcDate, utcTime) {
      return convertToLocalTime(utcDate, utcTime)
    },
    updateReceipt(e) {
      e.preventDefault();
      let receipt = {
        name: this.receipt.name,
        phone: this.receipt.phone,
        email: this.receipt.email,
        address: this.receipt.address,
        status: "ACTIVE",
      };
      receiptService.update(localStorage.getItem('mid'), this.receiptId, receipt)
        .then(response => {
          let success = response.data.success;
          if (success === true) {
            this.receipt = response.data.data;
            document.getElementById('showEditReceiptModal').click()
            this.retrieveReceipts()
            Swal.fire({
              icon: 'success',
              title: 'Done',
              text: "Successfully updated",
              footer: '<a href="">Why do I have this issue?</a>'
            })
          } else {
            this.fireNotification('error', "Oops", response.data.narrative)
          }
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', "Oops", "Error occurred")
        });
    },
    async downloadReceiptsPdf() {
      this.isLoading = true;
      try {
        const params = new URLSearchParams();

        // Apply filters to PDF export
        if (this.advancedFilters && this.advancedFilters.startDate) {
          params.append("fromDate", moment(this.advancedFilters.startDate).startOf('day').toISOString());
        }

        if (this.advancedFilters && this.advancedFilters.endDate) {
          params.append("toDate", moment(this.advancedFilters.endDate).endOf('day').toISOString());
        }

        params.append("page", this.currentPage);
        params.append("size", '1000000');
        params.append("op", 'like');
        params.append("sortBy", 'dateCreated');
        params.append("sortOrder", 'ASC');
        params.append("businessId", localStorage.getItem('mid'));

        // Add other filters
        if (this.advancedFilters) {
          if (this.advancedFilters.paymentMethodId) {
            params.append("paymentMethodId", this.advancedFilters.paymentMethodId);
          }

          if (this.advancedFilters.currency) {
            params.append("currency", this.advancedFilters.currency);
          }

          if (this.advancedFilters.minAmount) {
            params.append("minAmount", parseFloat(this.advancedFilters.minAmount) * 100);
          }

          if (this.advancedFilters.maxAmount) {
            params.append("maxAmount", parseFloat(this.advancedFilters.maxAmount) * 100);
          }
        }

        const businessId = localStorage.getItem('mid');
        const response = await axios.get(API_URL + `/v1/merchants/${businessId}/receipts/pdf?${params.toString()}&templateId=${this.selectedTemplateId}`, {
          responseType: "arraybuffer", // Important to handle binary data
          headers: authHeader(),
        });

        // Convert response data into a Blob
        const blob = new Blob([response.data], {type: "application/pdf"});

        // Generate Blob URL and trigger download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;

        // Create filename with dates if available
        let filename = "receipts";
        if (this.advancedFilters && this.advancedFilters.startDate && this.advancedFilters.endDate) {
          filename += `-${this.advancedFilters.startDate}-to-${this.advancedFilters.endDate}`;
        }
        a.download = filename + ".pdf";

        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error("Error downloading PDF:", e);
        await Swal.fire({
          icon: 'warning',
          title: 'Failed',
          text: e.response && e.response.data ? (e.response.data.narrative || e.response.data.description || 'Error whilst processing request') : 'Error whilst processing request',
          footer: '<a href="">Why do I have this issue?</a>'
        })
      } finally {
        this.isLoading = false;
      }
    },
    async downloadReceiptsExcel() {
      this.isLoading = true;
      try {
        const params = new URLSearchParams();

        // Apply filters to Excel export (same as PDF)
        if (this.advancedFilters && this.advancedFilters.startDate) {
          params.append("fromDate", moment(this.advancedFilters.startDate).startOf('day').toISOString());
        }

        if (this.advancedFilters && this.advancedFilters.endDate) {
          params.append("toDate", moment(this.advancedFilters.endDate).endOf('day').toISOString());
        }

        params.append("page", this.currentPage);
        params.append("size", '1000000');
        params.append("op", 'like');
        params.append("sortBy", 'dateCreated');
        params.append("sortOrder", 'ASC');
        params.append("businessId", localStorage.getItem('mid'));

        // Add other filters
        if (this.advancedFilters) {
          if (this.advancedFilters.paymentMethodId) {
            params.append("paymentMethodId", this.advancedFilters.paymentMethodId);
          }

          if (this.advancedFilters.currency) {
            params.append("currency", this.advancedFilters.currency);
          }

          if (this.advancedFilters.minAmount) {
            params.append("minAmount", parseFloat(this.advancedFilters.minAmount) * 100);
          }

          if (this.advancedFilters.maxAmount) {
            params.append("maxAmount", parseFloat(this.advancedFilters.maxAmount) * 100);
          }
        }

        const businessId = localStorage.getItem('mid');
        const response = await axios.get(API_URL + `/v1/merchants/${businessId}/receipts/excel?${params.toString()}`, {
          responseType: "arraybuffer", // Important to handle binary data
          headers: authHeader(),
        });

        // Convert response data into a Blob
        const blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});

        // Generate Blob URL and trigger download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;

        // Create filename with dates if available
        let filename = "receipts";
        if (this.advancedFilters && this.advancedFilters.startDate && this.advancedFilters.endDate) {
          filename += `-${this.advancedFilters.startDate}-to-${this.advancedFilters.endDate}`;
        }
        a.download = filename + ".xlsx";

        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error("Error downloading Excel:", e);
        await Swal.fire({
          icon: 'warning',
          title: 'Failed',
          text: e.response && e.response.data ? (e.response.data.narrative || e.response.data.description || 'Error whilst processing request') : 'Error whilst processing request',
          footer: '<a href="">Why do I have this issue?</a>'
        })
      } finally {
        this.isLoading = false;
      }
    },
    deleteReceipt(receiptId) {
      receiptService.delete(localStorage.getItem('mid'), receiptId)
        .then(response => {
          let success = response.data.success;
          if (success) {
            this.success = true;
            this.receipts = this.receipts.filter(function (item) {
              return item.id !== receiptId;
            });
            this.fireNotification('success', "Deleted", "Successfully deleted")
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.narrative,
              footer: '<a href="">Why do I have this issue?</a>'
            })
          }
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', "Error occurred", 5000)
        });
    },
    onPageChange(page) {
      this.currentPage = page
      this.retrieveReceipts()
    },
    onChangeRecordsPerPage() {
      this.retrieveReceipts()
    },
    viewReceipt(id) {
      this.$router.push(`/receipts/${id}`);
    },
    fireNotification(icon, message, timeout) {
      Swal.fire({
        toast: true,
        width: 300,
        position: 'top-end',
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: timeout,
        timerProgressBar: true,
      })
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isCustomerContact() {
      return selectedContextIsCustomerContact();
    },
    showButton() {
      // Hide button for customer contacts
      if (this.isCustomerContact) {
        return false; // Customer contacts cannot create receipts
      }
      
      if (this.showAddReceiptButton) {
        return true
      } else {
        return this.displayDisabledButtons
      }
    },
    isDisabled() {
      return !this.showAddReceiptButton
    },
    buttonTooltip() {
      return this.isDisabled ? 'You do not have access to this feature' : ''
    }
  },
  watch: {
    'selectedTime': {
      handler(beforeVal, afterVal) {
        // We no longer automatically retrieve receipts when selectedTime changes
        // Instead, we'll set the values in the filter and wait for the user to apply
        if (this.selectedTime && this.selectedTime.length === 2) {
          if (!this.advancedFilters) {
            this.advancedFilters = {};
          }
          this.advancedFilters.startDate = moment(this.selectedTime[0]).format('YYYY-MM-DD');
          this.advancedFilters.endDate = moment(this.selectedTime[1]).format('YYYY-MM-DD');
        }
      },
      deep: true
    },
    "caseId": {
      handler() {
        this.$refs.caseId = this.caseId
      }
    }
  },
  async mounted() {
    if (!this.currentUser) {
      await this.$router.push('/login')
      return
    }

    this.modules = allowedModules.filter(module => module.name === this.$i18n.locale)[0].modules;

    const result = await permissionService.checkPermissions(this.pagePermissions)

    if (!result.success) {
      console.error('Error during permission check', result.error)
      await Swal.fire({
        icon: 'warning',
        title: 'Failed',
        text: 'Permission check failed',
        footer: '<a href="">Why do l have this issue?</a>'
      })
      return
    }

    this.selectedTemplateId = 'receipts-report-1';

    this.permissions = result.data
    this.showAddReceiptButton = this.permissions['RECEIPT_CREATE'];

    // Initialize advanced filters with query parameters if available
    const startDateString = this.$route.query.startDate;
    const endDateString = this.$route.query.endDate;

    if (startDateString && endDateString) {
      this.advancedFilters = {
        startDate: moment(startDateString).format('YYYY-MM-DD'),
        endDate: moment(endDateString).format('YYYY-MM-DD')
      };
    }

    // Load receipts (without date filter by default)
    this.retrieveReceipts();

    this.customerId = this.$route.query.customerId;
    this.caseId = this.$route.query.caseId;
  }
}
</script>

<style scoped>
.search-container {
  width: 100%;
}

/* Responsive styles for the search bar and filters */
@media (max-width: 767px) {
  .input-group {
    flex-wrap: nowrap;
  }

  .input-group .btn {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .filter-text, .export-text {
    display: none;
  }

  /* Make buttons smaller on mobile */
  .input-group-append .btn {
    font-size: 0.875rem;
  }
}

@media (max-width: 576px) {
  /* Stack the pagination controls on very small screens */
  .dataTables_paginate {
    float: none !important;
    text-align: center !important;
    margin-top: 1rem !important;
  }

  .dataTables_info {
    text-align: center !important;
  }
}

/* Makes table more responsive */
.table-responsive {
  min-height: 150px;
}

button:disabled {
  cursor: not-allowed
}

.second-button {
  display: none !important;
}

@media (max-width: 768px) {
  .first-button {
    display: none !important;
  }

  .second-button {
    display: inline-block !important;
  }
}

/* Filter overlay */
.filter-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.filter-overlay.show {
  opacity: 1;
  visibility: visible;
}

/* Prevent body scroll when drawer is open */
:global(body.drawer-open) {
  overflow: hidden;
}

.btn-outline-default {
  color: #004A59;
  border-color: lightgrey;
}
</style>



// WEBPACK FOOTER //
// src/components/receipts/ReceiptList.vue